import {
  RESPONSE_CARS_BRANDS,
  REQUEST_CARS_BRANDS_FAILURE,
} from '../actions/carsBrandsActions'

import { states as queriesStates } from './queriesStates'

const initialState = {
  dataState: queriesStates.NOT_REQUESTED,
  brands: []
}

const carsBrandsReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESPONSE_CARS_BRANDS: {
      return Object.assign(
        {},
        state,
        {
          dataState: queriesStates.READY,
          brands: action.data
        }
      )
    }
    case REQUEST_CARS_BRANDS_FAILURE: {
      return Object.assign(
        {},
        state,
        {
          dataState: queriesStates.FAILURE,
          errors: action.errors,
        }
      )
    }
    default:
      return state
  }
}

export default carsBrandsReducer
